type Empty =
  | Map<unknown, unknown>
  | null
  | readonly []
  | Record<string, never>
  | Set<unknown>
  | undefined;

/** No type predicate for strings so that !isEmpty(s) does not narrow a non-empty string to never. */
export function isEmpty(value: string): boolean;

/** When false, narrows value by excluding Empty so callers can use the value without assertions. */
export function isEmpty(value: unknown): value is Empty;

export function isEmpty(value: unknown): boolean {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim() === '';
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
}
